<script setup>
import { getI18n } from '@/plugins/i18n'

const i18n = getI18n()

defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
})

const emit = defineEmits(['update:modelValue'])
</script>
<template>
  <q-btn
    :icon="modelValue ? 'mdi-flash' : 'mdi-flash-outline'"
    :color="modelValue ? 'primary' : 'grey-6'"
    flat
    round
    dense
    @click="emit('update:modelValue', !modelValue)"
  >
    <q-tooltip>{{ i18n.t('common.quickCreate') }}</q-tooltip>
  </q-btn>
</template>
